// extracted by mini-css-extract-plugin
export default {"boldText":"FormattedMessage_boldText__nxh18","formattedMessage":"FormattedMessage_formattedMessage__t4mGJ"};